<hpf-plateau-form
        [plateau]="plateau"
        [loading]="plateau.isNew()"
        (update)="onUpdate()"
        (delete)="onDelete()"
    ></hpf-plateau-form>
<div class="container">
</div>
